// Async XLSX export — enqueue a generate_export job, then poll until the
// presigned download URL is ready (or the job fails).

export type ExportResource =
  | 'checks_review'
  | 'checks_queue'
  | 'checks_processed'
  | 'new_items_queue'
  | 'new_items_processed'
  | 'all_items';

export interface ExportStatus {
  job_id: number;
  status: string;
  done: boolean;
  result_url: string | null;
  error: string | null;
}

export async function requestExport(
  resource: ExportResource,
  filters: Record<string, unknown>,
): Promise<number> {
  const res = await fetch('/api/v1/exports', {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ resource, filters }),
  });
  if (!res.ok) throw new Error(`Export request failed: ${res.status}`);
  const data = await res.json() as { job_id: number };
  return data.job_id;
}

export async function fetchExportStatus(jobId: number): Promise<ExportStatus> {
  const res = await fetch(`/api/v1/exports/${jobId}`, { credentials: 'include' });
  if (!res.ok) throw new Error(`Export status failed: ${res.status}`);
  return res.json() as Promise<ExportStatus>;
}
